export default {
//   root: "http://127.0.0.1:8000/api/v1/web",
    root: "https://cms.4x4motors.net/api/v1/web",
  defaultCompanyId: 1,
  defaultBranchId: 1,
};
